import React from 'react';
import {connect} from "react-redux";
import axios from 'axios';
import config from './../../../config';
import CustomPaper from './../../shared/utils/CustomPaper';
import CustomAppBarPublic from "../utils/CustomAppBarPublic";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import OkIcon from 'material-ui/svg-icons/action/verified-user';
import SuccessIcon from 'material-ui/svg-icons/action/check-circle';



class Inscription extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            dialog:{
                open:false
            },
            email:'',
            tel:'',
            nom:'',
            mdp:'',
            adresse:'',
            ville:'',
            cp:'',
            siret:''
        };
        window.scrollTo(0, 0);
        this.handleChange =this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleChange(event, value){
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    handleSubmit(x){
        axios.post(config.ws_path+'/public/inscription', this.state)
            .then(resp => this.setState({dialog:{open:true}}))
            .catch(err=> alert(err.response.data.payload));
    }

    render() {
        const actions = [
            <RaisedButton
                label="Se connecter"
                primary={true}
                onClick={()=>this.props.history.push('/')}
            />,
        ];
        return (
            <div>
                <CustomAppBarPublic/>
                <div className='row justify-content-md-center'>
                    <div className='col-12 col-md-10'><CustomPaper title='Inscription'>
                        <div className={'row'}>
                            <div className={'col'} style={{maxWidth:330}}>
                                <ValidatorForm
                                    ref="form"
                                    onSubmit={this.handleSubmit}
                                    onError={err =>alert('Les champs suivants sont obligatoires :\n'+ [...new Set(err.map(x => '\n'+x.props.floatingLabelText))])}
                                >
                                    <TextValidator
                                        floatingLabelText="Nom / Raison sociale"
                                        onChange={this.handleChange}
                                        name="nom"
                                        value={this.state.nom}
                                        validators={['required', 'trim']}
                                        errorMessages={['Ce champs est obligatoire', 'Nom invalide']}
                                    /><br/>
                                    <TextValidator
                                        floatingLabelText="Email"
                                        autoComplete="new-password"
                                        onChange={this.handleChange}
                                        name="email"
                                        value={this.state.email}
                                        validators={['required', 'isEmail']}
                                        errorMessages={['Ce champs est obligatoire', 'Email invalide']}
                                    /><br/>
                                    <TextValidator
                                        floatingLabelText="Mot de passe"
                                        autoComplete="new-password"
                                        onChange={this.handleChange}
                                        name="mdp"
                                        type="password"
                                        value={this.state.mdp}
                                        validators={['required', 'matchRegexp:^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\\w\\s]).{8,}$']}
                                        errorMessages={['Ce champs est obligatoire', 'Le Mot de passe doit être de longueur minimale 8 et doit contenir au moins 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial.']}
                                    /><br/>
                                    <TextValidator
                                        floatingLabelText="Téléphone"
                                        onChange={this.handleChange}
                                        name="tel"
                                        value={this.state.tel}
                                        validators={['required', 'isPositive']}
                                        errorMessages={['Ce champs est obligatoire', 'Numéro invalide']}
                                    /><br/>
                                    <TextValidator
                                        floatingLabelText="Adresse"
                                        onChange={this.handleChange}
                                        name="adresse"
                                        value={this.state.adresse}
                                        validators={['required']}
                                        errorMessages={['Ce champs est obligatoire']}
                                    /><br/>
                                    <TextValidator
                                        floatingLabelText="Ville"
                                        onChange={this.handleChange}
                                        name="ville"
                                        value={this.state.ville}
                                        validators={['required']}
                                        errorMessages={['Ce champs est obligatoire']}
                                    /><br/>
                                    <TextValidator
                                        floatingLabelText="Code Postal"
                                        onChange={this.handleChange}
                                        name="cp"
                                        value={this.state.cp}
                                        validators={['required', 'isPositive', 'minStringLength:5', 'maxStringLength:5']}
                                        errorMessages={['Ce champs est obligatoire', 'Format incorrect.', 'Format incorrect.', 'Format incorrect.']}
                                    /><br/>
                                    <TextValidator
                                        floatingLabelText="Siret"
                                        onChange={this.handleChange}
                                        name="siret"
                                        value={this.state.siret}
                                        validators={['required', 'isPositive', 'minStringLength:14', 'maxStringLength:14']}
                                        errorMessages={['Ce champs est obligatoire', 'Siret doit être de longueur 14.', 'Siret doit être de longueur 14.', 'Siret doit être de longueur 14.']}
                                    /><br/><br/>
                                    <RaisedButton type="submit" label={"S'inscrire"} />
                                </ValidatorForm>
                            </div>
                            <div className={'col text-center d-none d-md-block'} style={{position:'relative'}}>
                                <OkIcon style={{color:'green',position:'absolute', top:'31%', left:'27%', height:200, width:200}}/>
                                <strong style={{color:'blue',position:'absolute', top:'28%', left:'27%', height:200, width:200}}>Inscription sécurisée</strong>
                            </div>
                        </div>
                    </CustomPaper>
                    </div>
                </div>
                <Dialog
                    title="Inscription réussie"
                    titleStyle={{color:'green', textAlign:'center'}}
                    actions={actions}
                    modal={true}
                    contentStyle={{height:220}}
                    open={this.state.dialog.open}
                >
                    <div  style={{height:200, textAlign:'center'}}>
                        <SuccessIcon style={{color:'green',height:200, width:200}}/>
                    </div>
                    </Dialog>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {open: store.shared.drawer.open}
}

export default connect(mapStateToProps)(Inscription);


// WEBPACK FOOTER //
// ./src/components/shared/pages/Inscription.js